// removed by extract-text-webpack-plugin
module.exports = {"container":"_1xU3","imageContainer":"b9OT","teamContainer":"_2NoJ","textContainer":"_12FR","image":"_33MZ","name":"_3NPq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/JobDescription/Team/TeamMembers/styles.scss
// module id = 488
// module chunks = 0